import { render } from "./AppLoadingContainer.vue?vue&type=template&id=79baff2e"
import script from "./AppLoadingContainer.vue?vue&type=script&lang=js"
export * from "./AppLoadingContainer.vue?vue&type=script&lang=js"
script.render = render

export default script